import React from "react";
import { useLinkedIn } from "react-linkedin-login-oauth2";
import { useTranslation } from "react-i18next";

import { LinkedinIcon } from "../../../assets/image/LinkedinIcon";
import { authLinkedin } from "../../../api";

export function LinkedinContent({ profile, status, handleResponse }) {
  const { t } = useTranslation();

  const { linkedInLogin } = useLinkedIn({
    clientId: "860qiqz9pllqgi",
    redirectUri: "https://landing.mysenscare.com/linkedin",
    scope: "openid profile email",
    onSuccess: (response) => {
      fetchProfileLinkedin(response);
    },
    onError: (error) => {
      if (error.error === "user_closed_popup") {
        console.log("Korisnik je zatvorio LinkedIn prozor bez prijave.");
        return;
      }
      console.log(error);
    },
  });

  const fetchProfileLinkedin = async (accessToken) => {
    try {
      const result = await authLinkedin(accessToken);

      if (result.email) {
        handleResponse({
          profile: {
            email: result.email,
            type: "linkedIn",
          },
        });
      }
    } catch (error) {
      console.error("Error fetching profile data:", error);
    }
  };

  return (
    <>
      {profile ? (
        <LinkedinIcon
          onClick={linkedInLogin}
          className={status ? "active" : ""}
          color={"#B7B7B7"}
        />
      ) : (
        <a className="indi" onClick={linkedInLogin}>
          <i className="fa-brands fa-linkedin-in"></i>
          {t("log-in-linkedin")}
        </a>
      )}
    </>
  );
}
